import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { useShareActions } from '#src/app/shared/hooks/share';
import type { ShareAction, ShareActionsOptions } from '#src/app/shared/hooks/share';

import { useShareOptions } from './options';

type Result = {
	shareActions: readonly ShareAction[];
	/**
	 * The options the share actions were built with. Returned so that a share which runs outside the
	 * pipeline (the Facebook post sheet's CTA) reuses the same `onSuccess`, and with it the same
	 * `useRedirect` instance: each instance owns its own copy-link redirect timer.
	 */
	shareOptions: ShareActionsOptions;
};

export function usePsfShareAvailableShareActions(): Result {
	const shareOptions = useShareOptions();
	const {
		data: {
			petition: { shareLinks },
		},
	} = usePsfPromoteOrSharePageData();

	return { shareActions: useShareActions(shareLinks.links, shareOptions), shareOptions };
}
